import React from 'react';
import { VerticalSpacer } from '../components/VerticalSpacer';
import { TitleText } from './common';
import { CenteredDiv } from '../components/CenteredDiv';
import { Spinner } from 'js/design_system/Spinner';

type Props = {
  show: boolean;
};

export const LoadingPage: React.FC<Props> = (props) => {
  const { show } = props;
  return (
    <div style={{ display: show ? 'initial' : 'none' }}>
      <TitleText>Please hold while we log you in</TitleText>
      <VerticalSpacer height={40} />
      <CenteredDiv>
        <Spinner />
      </CenteredDiv>
    </div>
  );
};
